import { render, staticRenderFns } from "./TagSearchInput.vue?vue&type=template&id=497fb1f4&scoped=true&"
import script from "./TagSearchInput.vue?vue&type=script&lang=js&"
export * from "./TagSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./TagSearchInput.vue?vue&type=style&index=0&id=497fb1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fb1f4",
  null
  
)

component.options.__file = "TagSearchInput.vue"
export default component.exports